import React, { useCallback, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as routes from '../../routes/routes';
import { AppBar, Button, Container, Divider, IconButton, Menu, MenuItem, Select, Toolbar } from '@mui/material';
import { Box } from '@mui/system';
import { GlobalSettingsContext } from '../../firebase/GlobalSettingsContext';
import { UserDataContext } from '../../firebase/UserDataContext';
import { AdminPanelSettings, Festival, Gavel, HelpOutline, Menu as MenuIcon, People, SportsScore } from '@mui/icons-material';
import { FirebaseNewContext } from '../../firebase/FirebaseNewContext';
import { ROLES } from '../misc/Utils';

const Unauthorized = () => {
  const handleScrollToWalkthrough = useCallback(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const scrollSection = () => {
      const target = document.getElementById('walkthrough');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      window.location.hash = '#walkthrough';
    };

    if (window.location.pathname === routes.LANDING) {
      scrollSection();
      return;
    }

    window.location.href = `${routes.LANDING}#walkthrough`;
  }, []);

  const nonAuthNav = [
    { name: 'Home', route: routes.LANDING },
    { name: 'Demo', action: handleScrollToWalkthrough },
    { name: 'Sign In', route: routes.ACCOUNT }
  ];
  return (
    <Box sx={{ flexGrow: 1, display: { md: 'flex' }, alignItems: { md: 'center' } }}>
      {
        nonAuthNav.map((v, k) => {
          const buttonProps = v.route ? { component: Link, to: v.route } : {};
          return (
            <Button
              key={k}
              {...buttonProps}
              onClick={v.action}
              sx={{ color: 'white' }}
            >
              {v.name}
            </Button>
          );
        })
      }
    </Box>
  );
};

const Authorized = () => {
  const navigate = useNavigate()
  const { user } = useContext(UserDataContext)
  const { firebase } = useContext(FirebaseNewContext)
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleSignOut = useCallback(async () => {
    if (firebase?.doSignOut) {
      await firebase.doSignOut();
    }
    navigate(routes.LANDING);
  }, [firebase, navigate]);
  const adminNav = [
    { name: 'Admin Actions', route: routes.ADMIN_ACTIONS_PAGE },
    { name: 'Results Page', route: routes.RESULTS_V2 },
  ]
  const judgeNav = [
    { name: 'Event Scoresheet', route: routes.EVENT_SCORESHEET_PAGE }
  ]
  const teamNav = [
    { name: 'Invite Teammate', route: routes.INVITE_TEAMMATE_PAGE}

  ]
  const defaultAuthNavSandwhichTop = [
    { name: 'Dashboard', route: routes.DASHBOARD },
  ]
  const defaultAuthNavSandwhichBottom = [
    { name: 'Account', route: routes.ACCOUNT },
    { name: 'Signout', action: handleSignOut }
  ]

  let sandwhichMeat = []
  if (user.role === ROLES.ADMIN) {
    sandwhichMeat = adminNav
  } else if (user.role === ROLES.JUDGE) {
    sandwhichMeat = judgeNav
  } else if (user.role === ROLES.TEAM) {
    sandwhichMeat = teamNav
  }
  const nav = [...defaultAuthNavSandwhichTop, ...sandwhichMeat, ...defaultAuthNavSandwhichBottom]
  const mobileNav = [...nav, { name: 'Support', route: routes.SUPPORT }]

  return (


    <>
      <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
        <IconButton
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>
        <Menu
          anchorEl={anchorElNav}
          keepMounted
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: 'block', md: 'none' },
          }}
        >
          {
            mobileNav.map((v, k) => {
              return (
                <MenuItem key={k} onClick={handleCloseNavMenu}>
                  {
                    v.route &&
                    <Button component={Link} to={v.route}>{v.name}</Button>
                  }
                  {
                    v.action &&
                    <Button onClick={v.action}>{v.name}</Button>
                  }
                </MenuItem>
              )
            })
          }
        </Menu>
      </Box>
      <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, alignItems: { md: 'center' } }}>
        {
          nav.map((v, k) => {
            if (v.route) {
              return (
                <Button key={k} component={Link} to={v.route} sx={{ color: 'white' }}>{v.name}</Button>
              )
            }
            return (
              <Button key={k} onClick={v.action} sx={{ color: 'white' }}>
                {v.name}
              </Button>
            )

          })
        }
      </Box>
    </>

  )
}



function RoleIcon({ role }) {
    if ([ROLES.ADMIN].includes(role)) return <AdminPanelSettings />;
    if ([ROLES.SCORECOMMITTEE].includes(role)) return <SportsScore />;
    if ([ROLES.JUDGE].includes(role)) return <Gavel />;
    return <People />;
}

const Navbar = (props) => {
  const { globalSettings } = useContext(GlobalSettingsContext)
  const { user, defaultSelectedCompetition } = useContext(UserDataContext)
  const { firebase } = useContext(FirebaseNewContext)

  const whichComponent = () => {
    switch (true) {
      case Object.keys(globalSettings).length === 0 || Object.keys(user).length === 0:
        return <></>
      case !user.loggedIn:
        return <Unauthorized {...props} />
      default:
        return <Authorized />
    }
  }

    return (
        <AppBar
            position="fixed"
            sx={{ backgroundColor: "#293C8F", left: 0, right: 0 }}
        >
            <Container maxWidth="xl" disableGutters>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', width: '100%' }}>
                    <Toolbar disableGutters sx={{ flexGrow: 1, minHeight: 64 }}>
                        <Box sx={{ display: 'flex', flexGrow: 1 }}>
                            {whichComponent()}
                        </Box>
                    </Toolbar>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
                      {user && user.loggedIn ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', pr: 2, color: 'white', minWidth: 200, justifyContent: 'flex-end' }}>
                          <RoleIcon role={user.role} />
                          <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                              mx: 1.25,
                              borderColor: 'rgba(255,255,255,0.7)',
                              borderRightWidth: 2,
                            }}
                          />
                          <Festival sx={{ mr: 1}}/>
                          <Select
                            variant="standard"
                            value={defaultSelectedCompetition || ''}
                            onChange={(e) => firebase.setUserDefaultCompetition(user.uid, e.target.value)}
                            disableUnderline
                            sx={{
                              color: 'white',
                              fontWeight: 600,
                              fontSize: '1rem',
                              '& .MuiSelect-icon': { color: 'white' },
                            }}
                          >
                            {Object.entries(globalSettings?.competitions || {}).map(([key, name]) => (
                              <MenuItem key={key} value={key}>{name}</MenuItem>
                            ))}
                          </Select>
                        </Box>
                      ) : null }
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'stretch',
                                height: '100%',
                                width: {
                                    xs: 32,
                                    sm: 68,
                                    md: 132,
                                },
                            }}
                        >
                            <Box sx={{ width: '50%', backgroundColor: '#E51E3E' }} />
                            <Box sx={{ width: '50%', backgroundColor: '#FFE300' }} />
                        </Box>
                        {user && user.loggedIn ? (
                        <IconButton
                          component={Link}
                          to={routes.SUPPORT}
                          color="inherit"
                          aria-label="Support resources"
                          sx={{
                            border: '1px solid rgba(255,255,255,0.7)',
                            borderRadius: '50%',
                            width: 42,
                            height: 42,
                            p: 0,
                            display: { xs: 'none', md: 'inline-flex' },
                            position: 'fixed',
                            right: 10,
                            top: 10
                          }}
                        >
                          <HelpOutline sx={{ fontSize: 30 }} />
                        </IconButton>
                      ) : null}
                    </Box>
                </Box>
            </Container>
        </AppBar>
    )

}


export default Navbar;
